import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals'
import { AuthorizeContext }  from './RootContext';
import { CookiesProvider } from 'react-cookie';
import { AuthorizeProvider } from './RootContext';

import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/css/bootstrap-theme.css';
// import Enterbill from './enterbill';
// import Payable from './payable';
// import APSetup from './apsetup';

// const root = ReactDOM.createRoot(document.getElementById('root'));
const root =document.getElementById('root');
ReactDOM.render(
// root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>,
  // root
  // <CookiesProvider>
    <AuthorizeProvider>
      <App />
    </AuthorizeProvider>
  // </CookiesProvider>
  , document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
